/**
 * JSON-LD structured-data builders. Pass the output to <Seo jsonLd={...} />.
 * Keep values truthful, anything unverified should stay a placeholder and be
 * tracked in PLACEHOLDERS.md rather than asserted here.
 */

const SITE_URL = 'https://varehabphysicians.com';

const ORG_ID = `${SITE_URL}/#organization`;

export function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'MedicalOrganization',
    '@id': ORG_ID,
    name: 'Virginia Rehab Physicians',
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    medicalSpecialty: 'PhysicalMedicineAndRehabilitation',
    areaServed: { '@type': 'State', name: 'Virginia' },
    telephone: '+1-804-220-5770',
  };
}

export function physicianSchema(member) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Physician',
    name: member.name,
    jobTitle: member.designation,
    description: Array.isArray(member.message) ? member.message[0] : member.message,
    medicalSpecialty: 'PhysicalMedicineAndRehabilitation',
    worksFor: { '@id': ORG_ID },
    url: member.slug ? `${SITE_URL}/team/${member.slug}` : undefined,
  };
}

export function faqPageSchema(faqs = []) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: { '@type': 'Answer', text: f.answer },
    })),
  };
}

export function breadcrumbSchema(items = []) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}
